module.exports = __webpack_public_path__ + "media/images/vp/icon.trend.up-3eea68f3f74f3ec174bc5998d826fb78.svg";